import React, { Component } from 'react'
import moment from 'moment'
import { makeDefaultFailedContainer } from 'components/container'
import style from './style.styl'

const title = [
  <img style={{ width: '50%', margin: '1rem auto', display: 'block' }} src={ require('images/svg/mobile-signup.svg') } />,
  <div className="dsg-h2 color-blue">Almost There</div>
]

const copy = [
  <div className="color-gray-dark">
    <p>We just sent you an email to help you finish setting Drift up on a computer.</p>
    <p>It only takes 2 minutes to put Drift’s code snippet on your website and start talking to customers.</p>
  </div>
]

const image = (
  <div style={{ backgroundImage: `url(${require('images/getstarted-bg.png')})`,
                width: '100%',
                height: 150,
                backgroundSize: 'cover',
                backgroundPosition: '50% 50%',
                position: 'absolute',
                bottom: 0
              }}></div>
)

class EmailPrompt extends Component {
  static displayName = 'EmailPrompt'

  componentDidMount() {
    const timeThreshold = moment().subtract(5, 'minutes')
    const deliveredTime = this.props.settings.mobileWelcomeDeliveryTime

    // allow resend after five minutes
    if (!deliveredTime || moment(deliveredTime).isBefore(timeThreshold)) {
      const userId = this.props.currentUser.id
      const update = { mobileWelcomeDeliveryTime: moment() }

      this.app.actions.UserActions.sendWelcomeEmail(true)
      this.app.actions.UserPropertiesActions.updateProperties(userId, update)
    }
  }

  render() {
    return (

      <div style={{ height: "100vh", width: "100vw", position: "relative" }}>
        <div className={ `${style.Content} email-prompt` }>
          <img style={{ width: 123, height: 50 }} src={ require('images/svg/drift-logo-with-name.svg') } />
          <div className="dsg-medium-weight dsg-h3">
            { title }
          </div>
          <div>
            { copy }
          </div>
        </div>
        { image }
      </div>
    )
  }
}

export default makeDefaultFailedContainer(EmailPrompt, {
  listenTo: ['stores.UserStore', 'stores.UserPropertiesStore'],
  fetch: {
    currentUser() {
      return this.app.stores.UserStore.getOrFetchCurrentUser()
    },
    settings() {
      return this.app.stores.UserPropertiesStore.fetchPropertiesForCurrentUser()
    }
  }
})



// WEBPACK FOOTER //
// ./src/scripts/components/MobileLander/EmailPrompt.js